import type { GetExperiencesData } from '@/shared/api/experience';
import { unnull } from '@/shared/lib/converters';
import { EXP_TYPES } from '../../../const';
import { DEFAULT_SORTING } from '../../const/config';
import type { TTourFiltersPageState, TTourFiltersState } from '../../types/tour/state';

function getDefaultType() {
  return EXP_TYPES.TOUR;
}

function buildType(filters: TTourFiltersState): string {
  if (filters.tourFormat?.length) {
    return Array.from(new Set(filters.tourFormat)).join(',');
  }

  return getDefaultType();
}

export function tourFiltersToQuery(
  filters: TTourFiltersState,
  pageParams: TTourFiltersPageState,
  /** Раньше пробрасывалось в общий adapters; для турового стора не используется, оставлено для совместимости вызовов */
  _options?: { skipAddTourToType?: boolean; forceAddTourToType?: boolean },
) {
  void _options;
  const type = buildType(filters);

  const [startPrice, endPrice] = filters.price;
  const [startDuration, endDuration] = filters.duration;

  const toursActivities = filters.toursActivities ? filters.toursActivities.join(',') : null;
  const sorting = filters.sorting !== DEFAULT_SORTING ? filters.sorting : null;

  const childrenAllowed = filters.childrenAllowed || undefined;

  const comfort_type = filters.comfort_type.length ? filters.comfort_type.join(',') : undefined;
  const activity_level_category = filters.activity_level_category.length
    ? filters.activity_level_category.join(',')
    : undefined;
  const accommodation_type = filters.accommodation_type.length ? filters.accommodation_type.join(',') : undefined;
  // Баг на беке, TODO: выпилить каленым железом когда бек починят https://tripster.atlassian.net/browse/EXP-10237
  const normalizeDuration = (val: number | null) => {
    if (val === null) {
      return null;
    }

    // вычитаем 24 часа, только если значение ≥ 24
    return val >= 24 ? val - 24 : val;
  };

  const requestQuery: GetExperiencesData['query'] = {
    city__slug: pageParams.city,
    country__slug: pageParams.country,
    end_date: unnull(filters.date.to),
    end_price: unnull(endPrice),
    tour_activity_slugs: unnull(toursActivities),
    persons_count: unnull(filters.persons),
    region__slug: pageParams.region,
    start_date: unnull(filters.date.from),
    start_duration: unnull(normalizeDuration(startDuration)),
    end_duration: unnull(normalizeDuration(endDuration)),
    start_price: unnull(startPrice),
    tag__slugs: unnull(filters.tag__slugs),
    type: unnull(type),
    children_allowed: childrenAllowed,
    comfort_type: comfort_type,
    activity_level_category: activity_level_category,
    accommodation_type: accommodation_type,

    // @ts-expect-error TODO: чекнуть что там с сортировкой
    sorting,
  };

  return requestQuery;
}
